
export const projects = [{
    'url': 'SONICSHELTERS.COM',
    'title': 'Sonic Shelters: Facilitando la Reserva de Locales de Ensayo y Equipos',
    'description': ['Como músico, al alquilar locales de ensayo, frecuentemente veo a los encargados apuntar las reservas en grandes cuadernos arrugados. Esta práctica no sólo es ineficiente, sino que también puede llevar a errores y malentendidos.', 
        'Sonic Shelters es una plataforma que soluciona estos problemas al digitalizar el proceso de reserva, ofreciendo información clara y actualizada sobre la disponibilidad de locales y equipos.', 
        'Además, incluye secciones de gestión de clientes e historial de reservas y sus ingresos.'],
    'image1': "/assets/sonicshelters/sonicshelters.png",
    'image2': "/assets/sonicshelters/equipment.png",
    'image3': "/assets/sonicshelters/howitworks.png",
    'technologies': ['Laravel', 'Inertia', 'Breeze', 'React', 'Redux Toolkit', 'Bootstrap', 'React-big-calendar', 'MySQL', 'PHPUnit']
},

];